// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__-mmvb","accordion__header":"Accordion_accordion__header__ilPdD","accordion__content":"Accordion_accordion__content__nZmRc"};